// 默认维度配置
// 预设维度：所有维度和指标默认全部启用
export const defaultPresetDimensions = [
  {
    key: 'document',
    name: '单据维度',
    description: '以整张业务单据为单位进行统计',
    enabled: true,
    type: 'preset',
    icon: 'FileTextOutlined',
    presetMetrics: [
      { key: 'no_risk_precision', name: '无风险精确率', description: '识别为无风险的样本中，实际无风险的比例', enabled: true },
      { key: 'no_risk_recall', name: '无风险召回率', description: '实际无风险的样本中，被正确识别的比例', enabled: true },
      { key: 'risk_precision', name: '有风险精确率', description: '识别为有风险的样本中，实际有风险的比例', enabled: true },
      { key: 'risk_recall', name: '有风险召回率', description: '实际有风险的样本中，被正确识别的比例', enabled: true },
      { key: 'accuracy', name: '准确率', description: '所有预测正确的样本占总样本的比例', enabled: true }
    ],
    customMetrics: []
  },
  {
    key: 'rule_avg',
    name: '规则平均维度',
    description: '以（单据×规则）实例为单位，取平均值',
    enabled: true,
    type: 'preset',
    icon: 'BarChartOutlined',
    presetMetrics: [
      { key: 'no_risk_precision', name: '无风险精确率', description: '识别为无风险的样本中，实际无风险的比例', enabled: true },
      { key: 'no_risk_recall', name: '无风险召回率', description: '实际无风险的样本中，被正确识别的比例', enabled: true },
      { key: 'risk_precision', name: '有风险精确率', description: '识别为有风险的样本中，实际有风险的比例', enabled: true },
      { key: 'risk_recall', name: '有风险召回率', description: '实际有风险的样本中，被正确识别的比例', enabled: true },
      { key: 'accuracy', name: '准确率', description: '所有预测正确的样本占总样本的比例', enabled: true }
    ],
    customMetrics: []
  },
  {
    key: 'rule_detail',
    name: '规则明细维度',
    description: '以单据内具体审核规则为单位',
    enabled: true,
    type: 'preset',
    icon: 'DatabaseOutlined',
    presetMetrics: [
      { key: 'no_risk_precision', name: '无风险精确率', description: '识别为无风险的样本中，实际无风险的比例', enabled: true },
      { key: 'no_risk_recall', name: '无风险召回率', description: '实际无风险的样本中，被正确识别的比例', enabled: true },
      { key: 'risk_precision', name: '有风险精确率', description: '识别为有风险的样本中，实际有风险的比例', enabled: true },
      { key: 'risk_recall', name: '有风险召回率', description: '实际有风险的样本中，被正确识别的比例', enabled: true },
      { key: 'accuracy', name: '准确率', description: '所有预测正确的样本占总样本的比例', enabled: true }
    ],
    customMetrics: []
  }
];

// 自定义维度：默认为空数组，由用户自行添加
export const defaultCustomDimensions = [];

// 预设指标模板
export const presetMetricTemplate = [
  { key: 'no_risk_precision', name: '无风险精确率', description: '识别为无风险的样本中，实际无风险的比例', enabled: true },
  { key: 'no_risk_recall', name: '无风险召回率', description: '实际无风险的样本中，被正确识别的比例', enabled: true },
  { key: 'risk_precision', name: '有风险精确率', description: '识别为有风险的样本中，实际有风险的比例', enabled: true },
  { key: 'risk_recall', name: '有风险召回率', description: '实际有风险的样本中，被正确识别的比例', enabled: true },
  { key: 'accuracy', name: '准确率', description: '所有预测正确的样本占总样本的比例', enabled: true }
];

// 预设维度基础信息
export const presetDimensionInfo = [
  {
    key: 'document',
    name: '单据维度',
    description: '以整张业务单据为单位进行统计',
    icon: 'FileTextOutlined'
  },
  {
    key: 'rule_avg',
    name: '规则平均维度',
    description: '以（单据×规则）实例为单位，取平均值',
    icon: 'BarChartOutlined'
  },
  {
    key: 'rule_detail',
    name: '规则明细维度',
    description: '以单据内具体审核规则为单位',
    icon: 'DatabaseOutlined'
  }
];

// 配置说明文档
export const configDocumentation = {
  presetDimensions: {
    title: '预设维度',
    items: [
      { name: '单据维度', description: '以整张业务单据为单位进行指标统计' },
      { name: '规则平均维度', description: '以（单据×规则）实例为单位，对所有规则的指标取平均值' },
      { name: '规则明细维度', description: '以单据内具体审核规则为单位进行指标统计' }
    ]
  },
  presetMetrics: {
    title: '预设指标',
    items: [
      { name: '无风险精确率', description: '识别为无风险的样本中，实际无风险的比例' },
      { name: '无风险召回率', description: '实际无风险的样本中，被正确识别的比例' },
      { name: '有风险精确率', description: '识别为有风险的样本中，实际有风险的比例' },
      { name: '有风险召回率', description: '实际有风险的样本中，被正确识别的比例' },
      { name: '准确率', description: '所有预测正确的样本占总样本的比例' }
    ]
  },
  customDimensions: {
    title: '自定义维度',
    items: [
      { name: '维度名称', description: '自定义维度的显示名称' },
      { name: '维度代码', description: '用于脚本中引用的唯一标识' },
      { name: '基于维度', description: '选择基于哪个预设维度进行二次分组，或选择"无"创建独立维度' },
      { name: '预设指标', description: '每个维度都包含5个标准预设指标，可独立启用/禁用' },
      { name: '自定义指标', description: '可为每个维度添加特定的评测指标' }
    ]
  }
};

// 工具函数：获取默认配置
export const getDefaultConfig = () => ({
  presetDimensions: JSON.parse(JSON.stringify(defaultPresetDimensions)),
  customDimensions: JSON.parse(JSON.stringify(defaultCustomDimensions))
});

// 工具函数：重置为默认配置
export const resetToDefaultConfig = () => getDefaultConfig();

// 工具函数：创建新的自定义维度
export const createNewCustomDimension = (values) => ({
  ...values,
  key: values.code.toLowerCase(),
  type: 'custom',
  enabled: true,
  createdBy: 'current_user',
  createdAt: new Date().toISOString().split('T')[0],
  // 新增自定义维度时，预设指标默认全部启用
  presetMetrics: presetMetricTemplate.map(metric => ({
    ...metric,
    enabled: true
  })),
  customMetrics: []
});

// 工具函数：创建新的自定义指标
export const createNewCustomMetric = (values) => ({
  ...values,
  key: values.code.toLowerCase(),
  enabled: true,
  createdBy: 'current_user',
  createdAt: new Date().toISOString().split('T')[0]
});

// 工具函数：验证维度代码格式
export const validateDimensionCode = (code) => {
  if (!code) {
    return { valid: false, message: '请输入维度代码' };
  }
  if (!/^[A-Z_]+$/.test(code)) {
    return { valid: false, message: '维度代码只能包含大写字母和下划线' };
  }
  return { valid: true, message: '' };
};

// 工具函数：验证指标代码格式
export const validateMetricCode = (code) => {
  if (!code) {
    return { valid: false, message: '请输入指标代码' };
  }
  if (!/^[A-Z_]+$/.test(code)) {
    return { valid: false, message: '指标代码只能包含大写字母和下划线' };
  }
  return { valid: true, message: '' };
};
